import { ContributorProfile, Profile } from "@app/types/Cue";
import { cn } from "@util/helpers";

import BylineImage from "./BylineImage";
import BylineName from "./BylineName";
import { getSeparator } from "./helpers";

export type BylineProps = {
  profiles: (Profile | ContributorProfile)[];
  rootClassName?: string;
  bylineNameRootClassName?: string;
  imageWidth?: number;
  imageHeight?: number;
  timeStamp?: React.ReactElement;
  alwaysShowDefaultPhoto?: boolean;
  backdrop?: string;
  linkParams?: URLSearchParams;
};

export default function Byline({
  profiles = [],
  imageWidth = 50,
  imageHeight = 50,
  rootClassName,
  bylineNameRootClassName,
  timeStamp,
  backdrop,
  linkParams,
}: BylineProps): React.ReactElement {
  const profilesCount = profiles.length || 0;

  const profilesWithoutByline = profiles.find((profile) => {
    return !profile?.content.headshotImage?.[0]?.content.fields[
      "square_320-caas"
    ]?.url;
  });

  return (
    <>
      {profilesCount > 0 ? (
        <div
          className={cn(
            "flex flex-row items-start justify-start gap-2",
            rootClassName
          )}
          data-testid="byline-component"
        >
          {profilesCount >= 1 &&
          profilesCount <= 3 &&
          !profilesWithoutByline ? (
            <div className="flex flex-shrink-0 flex-row items-center justify-start">
              {profiles?.map((profile, index) => {
                return (
                  <BylineImage
                    key={profile.content.id}
                    rootClassName={cn({ "-translate-x-2": index !== 0 })}
                    profile={profile}
                    width={imageWidth}
                    height={imageHeight}
                    backdrop={backdrop}
                  />
                );
              })}
            </div>
          ) : null}

          <div
            className={cn("flex flex-col flex-wrap", {
              "pl-2": !profilesWithoutByline,
            })}
          >
            <div className="flex flex-wrap gap-x-1.5">
              {profiles?.map((profile, index) => {
                return (
                  <BylineName
                    key={profile.content.id}
                    profile={profile}
                    separator={getSeparator(index, profilesCount)}
                    rootClassName={cn(
                      "align-middle font-poppins font-semibold text-gray-850 leading-6 word-break text-base"
                    )}
                    linkClassName={bylineNameRootClassName}
                    linkParams={linkParams}
                  />
                );
              })}
            </div>

            {timeStamp}
          </div>
        </div>
      ) : (
        <div>{timeStamp}</div>
      )}
    </>
  );
}
